const img = require('./Metamask.png'); export default img;